var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessTravelSeparator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 143,
    viewBox: "0 0 100 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8782 142.143C97.8811 116.361 93.2706 88.304 86.2321 75.1239C76.8754 57.5971 60.5343 61.3551 55.9825 100.087C50.7013 75.8396 43.4636 57.8109 37.892 54.2163C35.0769 52.4017 32.6619 53.3011 32.6619 53.3011C31.04 53.9272 29.4979 56.2784 26.735 62.4174C24.7433 30.1063 16.457 5.94743 11.2299 3.61585C7.07905 1.76121 3.73996 13.1723 2.86219 29.6424",
    stroke: "#881B39",
    strokeWidth: 4.94432,
    strokeMiterlimit: 2.91243
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTravelSeparator);
export default __webpack_public_path__ + "static/media/business-travel-separator.54da88cd36edfb4e417d9cd360b464b0.svg";
export { ForwardRef as ReactComponent };